var isMobile = window.innerWidth < 712
export const citycollections_de = {
  poorcenterrichputskirts: {
    title: 'Ärmeres Zentrum, wohlhabende Ränder',
    lead: (
      <>
        <p>
          In einigen kleineren Städten in der Schweiz zeigt sich ein spezielles
          Muster: In der Innenstadt wohnen die ärmeren Leute, an den Rändern die
          reicheren. Biel und La Chaux-de-Fonds sind zwei Beispiele.
          ETH-Professor Kaufmann vermutet, dass da noch der Effekt der
          «A-Städte» nachwirkt, wie er in den Jahren 1970 bis 2000 beobachtet
          wurde. A-Stadt bedeutet, dass die Reichen eher an die Ränder ziehen
          und die Zentren vor allem von Armen, Arbeitslosen, Alten und
          Alkoholikern bewohnt werden. Kaufmann sagt, solche Muster seien eher
          die Ausnahme. Die beiden Städte seien wirtschaftlich nicht so stark
          gewachsen wie andere Städte.
        </p>
      </>
    ),
    images: [
      {
        label: 'Biel',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_1_a_mob.jpg')
          : require('../../Content/Maps/maps_muster_1_a.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_1_a_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_1_a_dm.jpg'),
      },
      {
        label: 'La Chaux-de-Fonds',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_1_b_mob.jpg')
          : require('../../Content/Maps/maps_muster_1_b.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_1_b_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_1_b_dm.jpg'),
      },
    ],
  },
  richcentrepoorputskirts: {
    title: 'Wohlhabendes Zentrum, ärmere Ränder',
    lead: (
      <>
        <p>
          Ein häufigeres Muster ist jedoch das umgekehrte: Im Zentrum leben die
          Reichen, an den Rändern die weniger Wohlhabenden. Beispiele dafür sind
          Solothurn und Thun. Grundsätzlich ist eine zentrale Wohnlage in einer
          Kleinstadt attraktiv – laut Kaufmann vor allem auch für Pendlerinnen
          und Pendler.
        </p>
      </>
    ),
    images: [
      {
        label: 'Solothurn',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_2_a_mob.jpg')
          : require('../../Content/Maps/maps_muster_2_a.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_2_a_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_2_a_dm.jpg'),
      },
      {
        label: 'Thun',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_2_b_mob.jpg')
          : require('../../Content/Maps/maps_muster_2_b.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_2_b_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_2_b_dm.jpg'),
      },
    ],
  },
  mosaiccities: {
    title: 'Mosaikstädte',
    lead: (
      <>
        <p>
          Die häufigste Struktur einer Schweizer Kleinstadt ähnelt jedoch einem
          Mosaik. Wohnquartiere mit reicheren und ärmeren Leuten wechseln sich
          ab. «Gerade im Vergleich mit grösseren Städten wie Bern oder Zürich
          sind solche regionalen Zentren besser durchmischt», sagt
          Wissenschaftler Kaufmann. Beispiele für solche Mosaikstädte sind
          Burgdorf im Kanton Bern und Kreuzlingen.
        </p>
      </>
    ),
    images: [
      {
        label: 'Kreuzlingen',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_3_a_mob.jpg')
          : require('../../Content/Maps/maps_muster_3_a.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_3_a_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_3_a_dm.jpg'),
      },
      {
        label: 'Burgdorf',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_3_b_mob.jpg')
          : require('../../Content/Maps/maps_muster_3_b.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_3_b_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_3_b_dm.jpg'),
      },
    ],
  },
  weakvspower: {
    title: 'Strukturschwäche vs. Wirtschaftskraft ',
    lead: (
      <>
        <p>
          Offenkundig werden auch die Unterschiede zwischen strukturschwachen
          und prosperierenden Regionen. Im Wallis, im Jura oder im Tessin leben
          viel mehr ärmere Leute – zumindest gemessen am Schweizer Schnitt.
          Besonders strukturschwach ist beispielsweise die Stadt Martigny im
          Wallis mit ihren rund 20’000 Einwohnern. Vier mehr Wohlhabende leben
          dagegen in Städten aus wirtschaftsstarken Regionen wie zum Beispiel
          Zug (mit rund 30’000 Einwohnern).
        </p>
      </>
    ),
    images: [
      {
        label: 'Martigny',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_4_a_mob.jpg')
          : require('../../Content/Maps/maps_muster_4_a.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_4_a_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_4_a_dm.jpg'),
      },
      {
        label: 'Zug',
        image: isMobile
          ? require('../../Content/Maps/maps_muster_4_b_mob.jpg')
          : require('../../Content/Maps/maps_muster_4_b.jpg'),
        image_dm: isMobile
          ? require('../../Content/Maps/maps_muster_4_b_dm_mob.jpg')
          : require('../../Content/Maps/maps_muster_4_b_dm.jpg'),
      },
    ],
  },
}
